<template>
    <v-row id="navigation" no-gutters>
        <v-col align-self="center" justify="center">
            <h1 v-if="user.data !== null && user.data.email !== ''">
                <router-link to="/entries">
                    Diario
                </router-link>
            </h1>
            <h1 v-else>
                Diario
            </h1>
        </v-col>
        <v-col cols="3" id="buttons" class="text-right">
            <v-btn
                icon
                color="red"
                v-if="user.data !== null && user.data.email !== ''"
                @click="signout"
            >
                <v-icon>mdi-exit-to-app</v-icon>
            </v-btn>
            <v-btn icon color="primary" @click="toggle_dark_mode">
                <v-icon>mdi-theme-light-dark</v-icon>
            </v-btn>
        </v-col>
    </v-row>
</template>

<script>
import { mapGetters } from "vuex";
import firebase from "firebase";
export default {
    computed: {
        ...mapGetters({
            user: "user"
        })
    },
    mounted() {
        const theme = localStorage.getItem("dark_theme");
        if (theme) {
            if (theme === "true") {
                this.$vuetify.theme.dark = true;
            } else {
                this.$vuetify.theme.dark = false;
            }
        } else if (
            window.matchMedia &&
            window.matchMedia("(prefers-color-scheme: dark)").matches
        ) {
            this.$vuetify.theme.dark = true;
            localStorage.setItem(
                "dark_theme",
                this.$vuetify.theme.dark.toString()
            );
        }
    },
    methods: {
        toggle_dark_mode: function() {
            if (this.debug) console.log("Toggling dark mode...");
            if (this.debug) console.log(this.$vuetify.theme.dark);
            this.$vuetify.theme.dark = !this.$vuetify.theme.dark;
            if (this.debug) console.log(this.$vuetify.theme.dark);
            localStorage.setItem(
                "dark_theme",
                this.$vuetify.theme.dark.toString()
            );
        },
        signout: function() {
            firebase
                .auth()
                .signOut()
                .then(() => {
                    this.$router.replace({
                        name: "Signin"
                    });
                })
                .catch(error => console.error(error));
        }
    }
};
</script>

<style scoped>
#navigation {
    padding: 30px 0;
}

#navigation a {
    text-decoration: none;
    font-weight: bold;
}

#navigation a.router-link-exact-active {
    color: #9c27b0;
}

#navigation #buttons button {
    margin: 0 7.5px;
}
</style>
